import axios from 'axios';

// FMAS backend — used only for authentication (login/OTP). This app shares
// the same JWT_SECRET as FMAS and accounts-service, so a token minted here
// is trusted by accounts-service too.
const API_URL = process.env.REACT_APP_FMAS_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('fmas_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('fmas_token');
      localStorage.removeItem('fmas_user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
